import React, {
  useState,
  useMemo,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import html2canvas from "html2canvas";
import { Card, Row } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { PDFDocument } from "pdf-lib";
import "./PrescriptionPreview.scss";
import {
  formatDateIST,
  formatAppointmentTypeForPdf,
  getHumanReadableDiffInPastDate,
  getHumanReadableDurationInDate,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import { sections } from "../../pages/doctor-console/initialData/initialData";
import { BrandingContext } from "../../BrandingProvider";
import { usePermissions } from "../../pages/login/PermissionContext";
import NavLogoFooter from "../../assets/images/logo/NavLogo_new.png";
import { isTodayOrFuture } from "../../pages/utils/utils";
import { displayPatientName } from "../../utils/displayPatientName";
const PrintPrescriptionforButtonDropdown = forwardRef(
  (
    {
      selectedSectionsData,
      historyDetails,
      sectionsContent,
      doctorData,
      hasVitalValue,
      vitals,
      hasDentalData,
      dentalData,
      prescribedMedicines,
      patientData,
      bloodGroup,
      selectedContext,
      selectedContextDisplay,
      followUpError,
      referralError,
      departments,
      // showTopHeader = false,
      // extraBottomMargin = 0,
      // extraRightMargin = 0,
      // useBackgroundTemplate = true,
      // printOfsetTop = -25,
      // printOfsetLeft = -20,
      showFooter: showFooterProp = true,
      showTopHeader: showTopHeaderProp = true,
      dateForAppointment,
      startTime
    },
    ref
  ) => {
    const [newSectionsWithData, setNewSectionsWithData] = useState(sections);
    const { userInfo } = usePermissions();

    const brandingData = useContext(BrandingContext);

    // Get template config from brandingData (context API)
    const prescriptionConfigItem = brandingData?.find(
      (item) =>
        item.name === "prescription_config" || item.name === "template_config"
    );
    const templateConfigFromContext = prescriptionConfigItem?.content
      ? typeof prescriptionConfigItem.content === "string"
        ? JSON.parse(prescriptionConfigItem.content)
        : prescriptionConfigItem.content
      : null;

    // Get template from brandingData (context API) or fallback to userInfo
    const prescriptionTemplateItem = brandingData?.find(
      (item) =>
        item.name === "prescription_template" || item.name === "template"
    );
    const templateBase64 =
      prescriptionTemplateItem?.content || userInfo?.template || null;
    const hasTemplateBackground = Boolean(templateBase64);

    // Merge template config: context API > userInfo > props > defaults
    const templateConfig = {
      showTopHeader:
        templateConfigFromContext?.showTopHeader ??
        userInfo?.template_config?.showTopHeader ??
        showTopHeaderProp ??
        true,
      showFooter:
        templateConfigFromContext?.showFooter ??
        userInfo?.template_config?.showFooter ??
        showFooterProp ??
        true,
      extraBottomMargin:
        templateConfigFromContext?.extraBottomMargin ??
        userInfo?.template_config?.extraBottomMargin ??
        0,
      extraRightMargin:
        templateConfigFromContext?.extraRightMargin ??
        userInfo?.template_config?.extraRightMargin ??
        0,
      extraLeftMargin:
        templateConfigFromContext?.extraLeftMargin ??
        userInfo?.template_config?.extraLeftMargin ??
        0,
      extraTopMargin:
        templateConfigFromContext?.extraTopMargin ??
        userInfo?.template_config?.extraTopMargin ??
        0,
      useBackgroundTemplate:
        templateConfigFromContext?.useBackgroundTemplate ??
        userInfo?.template_config?.useBackgroundTemplate ??
        false,
      printOfsetTop:
        templateConfigFromContext?.printOfsetTop ??
        userInfo?.template_config?.printOfsetTop ??
        0,
      printOfsetLeft:
        templateConfigFromContext?.printOfsetLeft ??
        userInfo?.template_config?.printOfsetLeft ??
        0,
      showDoctorSignature:
        templateConfigFromContext?.showDoctorSignature ??
        userInfo?.doctor_requires_prescription_signature ??
        userInfo?.template_config?.showDoctorSignature ??
        true,
    };

    // Align all inline label/value sections using a fixed label column width
    const INLINE_LABEL_COLUMN_WIDTH = 140;
    console.log("DoctorData from preview page", doctorData);
    console.log(
      "Selected Section Data from preview page",
      selectedSectionsData
    );
    console.log("History Details", historyDetails);

    const brandingItem = brandingData?.find(
      (item) => item.name === "branding_statements"
    );
    const collateralBrandStatement =
      brandingItem?.content?.collateralBrandStatement || "";
    const collateralImage =
      brandingData?.find((item) => item.name === "collateral_image")?.content ||
      "";
    // Optional full-page/background overlay image (base64) for pre-printed prescription
    // Try from branding first; fallback to sessionStorage key 'prescriptionOverlayImage'
    const overlayImageBase64 =
      brandingData?.find((item) => item.name === "prescription_overlay_image")
        ?.content ||
      sessionStorage.getItem("prescriptionOverlayImage") ||
      "";
    const pageWidth = 595.28;
    const pageHeight = 841.89;
    const baseMargin = 40;

    // Extract configuration values
    const {
      showTopHeader: configShowTopHeader = true,
      showFooter: configShowFooter = true,
      extraBottomMargin = 0,
      extraRightMargin = 0,
      extraLeftMargin = 0,
      extraTopMargin = 0,
      useBackgroundTemplate = false,
      printOfsetTop = 0,
      printOfsetLeft = 0,
      showDoctorSignature = true,
    } = templateConfig;

    // Calculate effective margins (base + extra from config)
    const EFFECTIVE_LEFT_MARGIN = baseMargin + extraLeftMargin;
    const EFFECTIVE_TOP_MARGIN = baseMargin + extraTopMargin;

    // Extra printable area offsets for pre-printed stationery (separate from extra margins)
    const PRINT_OFFSET_LEFT = printOfsetLeft;
    const PRINT_OFFSET_TOP = printOfsetTop; // increase to move content down
    // Optional overlay (watermark) on top of content
    const SHOW_RX_OVERLAY = false; // set to true to enable text/image watermark
    const RX_OVERLAY_OPACITY = 0.08; // keep low so text remains readable
    // Footer visibility flag - use config from context API, fallback to prop
    const SHOW_FOOTER =
      typeof configShowFooter === "boolean"
        ? configShowFooter
        : typeof showFooterProp === "boolean"
          ? showFooterProp
          : true;

    const CONTENT_BOTTOM_MARGIN = 80;
    // Additional configurable bottom margin (in points) to push content up
    const EXTRA_CONTENT_BOTTOM_MARGIN = Number(extraBottomMargin ?? 0) || 0;
    const EFFECTIVE_BOTTOM_MARGIN =
      CONTENT_BOTTOM_MARGIN + EXTRA_CONTENT_BOTTOM_MARGIN;

    // Additional configurable right margin for content and tables
    const EXTRA_RIGHT_MARGIN = Number(extraRightMargin ?? 0) || 0;
    const EFFECTIVE_RIGHT_MARGIN = baseMargin + EXTRA_RIGHT_MARGIN;
    const RIGHT_EDGE_OFFSET = baseMargin + EXTRA_RIGHT_MARGIN;

    // Toggle top header visibility - use config from context API, fallback to prop
    const SHOW_TOP_HEADER =
      typeof configShowTopHeader === "boolean"
        ? configShowTopHeader
        : typeof showTopHeaderProp === "boolean"
          ? showTopHeaderProp
          : true;
    // Static content top margin for sections below header
    //

    // Compute the Y position where main content should start, based on actual header height.
    // Mirrors renderHeaderFooter calculations (without drawing) so content never overlaps the header.
    const computeContentStartY = (doc) => {
      if (!SHOW_TOP_HEADER) return EFFECTIVE_TOP_MARGIN + PRINT_OFFSET_TOP + 20;

      const baseY = EFFECTIVE_TOP_MARGIN + PRINT_OFFSET_TOP;
      const doctorY = baseY + 40;
      const midX = pageWidth / 2 + 10 + PRINT_OFFSET_LEFT;
      const clinicAddressY = doctorY + 45;
      const rightColumnLineHeight = 12;
      const lineHeight = 12;
      const lineSpacing = 5;
      // Keep text measurement in sync with renderHeaderFooter to avoid extra white space.
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);

      // Left column height
      let leftY = doctorY + 16; // bold 14pt name
      const qualificationsText = `${doctorData?.qualifications || ""}`;
      if (qualificationsText.trim()) {
        const wrappedQual = doc.splitTextToSize(qualificationsText, pageWidth / 2 - 40);
        leftY += wrappedQual.length * 12;
      }
      leftY += 12; // Reg No
      if (doctorData?.phone_no) leftY += 12; // Contact
      if (doctorData?.email) leftY += 12; // Email

      // Right column height (clinic address)
      const clinicAddress = [
        sessionStorage.getItem("facilityAddressLine1"),
        sessionStorage.getItem("facilityAddressLine2"),
        sessionStorage.getItem("facilityAddressLine3"),
      ].filter(Boolean).join(", ");
      const rightColumnWidth = Math.max(80, pageWidth - midX - 40);
      const wrappedClinicAddress = doc.splitTextToSize(
        `Clinic Address: ${clinicAddress}`,
        rightColumnWidth
      );
      const rightColumnBottom = clinicAddressY + wrappedClinicAddress.length * rightColumnLineHeight + 5;

      const patientY = Math.max(leftY + 5, rightColumnBottom);

      // Patient section
      const availableWidth =
        pageWidth - (EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT) - EFFECTIVE_RIGHT_MARGIN;
      // Line 1: name (bold)
      const patientNameLine = [
        patientData?.patient_id ? `ID: ${patientData.patient_id}` : null,
        `Patient: ${displayPatientName(patientData?.name)}`,
      ].filter(Boolean).join(" | ");
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      const wrappedPatientLine = doc.splitTextToSize(patientNameLine, availableWidth);
      doc.setFont("helvetica", "normal");
      let patientSectionY = patientY + wrappedPatientLine.length * lineHeight + lineSpacing;

      const appointmentDateTime = (() => {
        if (!dateForAppointment) return null;
        const formattedDateTime = formatDateIST(dateForAppointment.toISOString());
        const datePart = formattedDateTime?.split(" ")?.[0];
        const timePart = isTodayOrFuture(dateForAppointment)
          ? formatDateIST(new Date().toISOString()).split(" ").slice(1).join(" ")
          : startTime;
        if (!datePart && !timePart) return null;
        return `DT: ${[datePart, timePart].filter(Boolean).join(" ")}`;
      })();

      // Line 2: appointment type | phone | age | gender | date time
      const ageLine = [
        `Appointment type: ${formatAppointmentTypeForPdf(
          patientData?.appointment_type
        )}`,
        patientData?.phone_no ? `Ph: ${patientData.phone_no}` : null,
        patientData?.age ? `Age: ${patientData.age}y` : null,
        patientData?.gender ? `G: ${patientData.gender}` : null,
        appointmentDateTime,
      ].filter(Boolean).join(" | ");
      if (ageLine) {
        const wrappedAgeLine = doc.splitTextToSize(ageLine, availableWidth);
        patientSectionY += wrappedAgeLine.length * lineHeight + lineSpacing;
      }

      const abhaParts = [];
      if (patientData?.abha_id) abhaParts.push(`ABHA Address: ${patientData.abha_id}`);
      if (patientData?.abha_no) abhaParts.push(`ABHA Number: ${patientData.abha_no}`);
      if (abhaParts.length > 0) {
        const wrappedAbhaLine = doc.splitTextToSize(
          abhaParts.join(" | "),
          availableWidth
        );
        patientSectionY += wrappedAbhaLine.length * lineHeight + lineSpacing;
      }

      // separator (5) + 2 units space before first content section
      return patientSectionY + 5 + 2;
    };

    // Ensure there is enough space to start a new section; otherwise move to next page
    const ensureSpaceForSection = (doc, startY, minNeeded = 160) => {
      const available = pageHeight - startY - EFFECTIVE_BOTTOM_MARGIN;
      if (available < minNeeded) {
        doc.addPage();
        // Draw header on new page and use its returned Y as the content start.
        return renderHeaderFooter({}, doc);
      }
      return startY;
    };

    const renderInlineTextSection = (
      doc,
      startY,
      label,
      text,
      options = {}
    ) => {
      const trimmedText = typeof text === "string" ? text.trim() : "";

      if (!trimmedText) {
        return startY;
      }

      const {
        fontSize = 10,
        labelFontSize = 10,
        gap = 6,
        extraSpacing = 10,
        lineHeight: customLineHeight,
        labelColumnWidth = INLINE_LABEL_COLUMN_WIDTH,
      } = options;

      const lineHeight = customLineHeight || fontSize + 4;
      const labelX = EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT;
      const baseLabelText = `${label}:`;
      const contLabelText = `${label} (cont.):`;
      const labelLineHeight = lineHeight;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(labelFontSize);
      doc.setTextColor("#000");

      const textStartX = labelX + labelColumnWidth + gap;
      const availableWidth = Math.max(
        60,
        pageWidth - RIGHT_EDGE_OFFSET - textStartX
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(fontSize);

      const lines = doc.splitTextToSize(trimmedText, availableWidth);
      let currentY = startY;
      let lineIndex = 0;
      let labelForPage = baseLabelText;
      let labelPrintedOnPage = false;

      while (lineIndex < lines.length) {
        const needsLabelThisPage = !labelPrintedOnPage;
        const labelLines = needsLabelThisPage
          ? doc.splitTextToSize(labelForPage, labelColumnWidth)
          : [];
        const requiredHeight =
          (needsLabelThisPage
            ? Math.max(labelLines.length * labelLineHeight, lineHeight)
            : lineHeight) + extraSpacing;

        const prevY = currentY;
        currentY = ensureSpaceForSection(doc, currentY, requiredHeight);
        const pageBreak = currentY < prevY;

        if (pageBreak) {
          labelPrintedOnPage = false;
          labelForPage = contLabelText;
          continue;
        }

        if (!labelPrintedOnPage) {
          doc.setFont("helvetica", "bold");
          doc.setFontSize(labelFontSize);
          labelLines.forEach((labelLine, idx) => {
            doc.text(labelLine, labelX, currentY + idx * labelLineHeight);
          });
          doc.setFont("helvetica", "normal");
          doc.setFontSize(fontSize);
          labelPrintedOnPage = true;
        }

        doc.text(lines[lineIndex], textStartX, currentY);
        lineIndex += 1;
        currentY += lineHeight;
      }

      return currentY + extraSpacing;
    };

    // Main PDF Export Function
    // Main PDF Export Function
    const handleDownload = async (withHeaders, type) => {
      // const PRINT_OFFSET_LEFT = printOfsetLeft;
      // const PRINT_OFFSET_TOP = printOfsetTop;

      const doc = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: "a4",
        compress: true,
      });

      // Override useBackgroundTemplate based on type and withHeaders for Prescription
      let shouldUseTemplate = useBackgroundTemplate && hasTemplateBackground;
      if (type === "Prescription") {
        // For Prescription: use template when withHeaders is true, don't use when false
        shouldUseTemplate = withHeaders === true && hasTemplateBackground;
      }
      // For other types, use the existing config (shouldUseTemplate remains as useBackgroundTemplate)

      const brandingItem = brandingData?.find(
        (item) => item.name === "branding_statements"
      );
      const themeColour = brandingItem?.content?.themeColour || "#21cdc0";

      // Start after header (dynamic — grows with qualifications / patient data).
      // renderHeaderFooter draws the header on page 1 and returns the exact Y
      // just below the separator line, guaranteeing content aligns with it.
      let currentY = renderHeaderFooter({}, doc);

      currentY = renderExaminationsToPdf(
        doc,
        currentY,
        themeColour,
        vitals,
        bloodGroup,
        dentalData
      );

      // currentY = renderDrugHistoryToPdf(
      //   doc,
      //   currentY,
      //   themeColour,
      //   historyDetails
      // );
      currentY = renderChiefComplaintsToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["Chief Complaints"] || []
      );
      // 7. Render Other Sections
      currentY = renderOtherSectionsToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["Diagnosis"] || []
      );

      currentY = renderAdultVaccinationToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["Adult Vaccination"] ||
        selectedSectionsData["Adult Vaccinations"] ||
        []
      );

      currentY = renderMedicalAdviceToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["MedicalAdvice"] || {}
      );

      if (selectedSectionsData["Medications"]?.length > 0) {
        currentY = ensureSpaceForSection(doc, currentY);
        // currentY += 5;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor("#000");
        doc.text("Rx", EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT, currentY);
        doc.setFont("helvetica", "normal");
        currentY += 10;

        autoTable(doc, {
          startY: currentY,
          head: [
            [
              "Drug",
              "Timing",
              "Frequency",
              "Dosage",
              "Additional Instructions",
              "Route",
              "Duration",
              //  "Instruction",
              "Note",
            ],
          ],
          body: selectedSectionsData["Medications"].map((item) => [
            item.term || "-",
            [item?.time, item?.when].filter(Boolean).join(" ") || "-",
            item?.frequency || "-",
            item?.dosage || "-",
            Array.isArray(item?.additionalInstructions)
              ? item?.additionalInstructions.map((option) => option.term).join(", ")
              : item?.additionalInstructions || "-",
            item.selectedAdministration?.label || "-",
            item.duration ? `${item.duration} ${item.durationType}` : "-",
            // item.instructions || "-",
            item.medicineNote || "-",
          ]),
          theme: "striped",
          styles: { fontSize: 9 },
          headStyles: {
            fillColor: hexToRgbArray("#EEEEEE"),
            textColor: hexToRgbArray("#000000"),
            fontSize: 9,
          },
          margin: {
            top: 250 + PRINT_OFFSET_TOP,
            left: EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
            right: EFFECTIVE_RIGHT_MARGIN,
            bottom: EFFECTIVE_BOTTOM_MARGIN,
          },
          didDrawPage: (data) => renderHeaderFooter(data, doc),
        });

        currentY = doc.lastAutoTable.finalY + 20;
      }

      currentY = renderInvestigationToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["Tests/Investigations"] || []
      );

      // 6. Render Follow-up & Referral
      currentY = renderAppointmentToPdf(
        doc,
        currentY,
        themeColour,
        selectedSectionsData["FollowUp"],
        selectedSectionsData["Referral"]
      );
      // Rendering doctor signature at the end
      if (showDoctorSignature) {
        currentY = ensureSpaceForSection(doc, currentY, 110);
        currentY = renderDoctorSignatureBlock(doc, currentY);
      }

      // Ensure footer is added on every page (even non-autoTable ones)
      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        renderHeaderFooter({}, doc); // add header
        if (SHOW_FOOTER) {
          renderFooter(doc, i); // add footer with correct page number
        }
      }

      // Post-process: optionally compose a new PDF with the template as background
      let finalBytes;
      if (shouldUseTemplate) {
        try {
          const srcBytes = doc.output("arraybuffer");
          const templateBytes = Uint8Array.from(atob(templateBase64), (c) =>
            c.charCodeAt(0)
          );

          const newDoc = await PDFDocument.create();
          const srcDoc = await PDFDocument.load(srcBytes);
          const pageCount = srcDoc.getPageCount();

          for (let i = 0; i < pageCount; i++) {
            const [embeddedSrcPage] = await newDoc.embedPdf(srcBytes, [i]);
            const [embeddedTemplatePage] = await newDoc.embedPdf(
              templateBytes,
              [0]
            );

            const pageWidth = embeddedSrcPage.width;
            const pageHeight = embeddedSrcPage.height;

            const page = newDoc.addPage([pageWidth, pageHeight]);
            // Draw template first (background, full-bleed)
            page.drawPage(embeddedTemplatePage, {
              x: 0,
              y: 0,
              width: pageWidth,
              height: pageHeight,
            });
            // Draw generated jsPDF page content on top
            page.drawPage(embeddedSrcPage, {
              x: 0,
              y: 0,
              width: pageWidth,
              height: pageHeight,
            });
          }

          finalBytes = await newDoc.save();
        } catch (e) {
          // If overlay fails, fall back to plain jsPDF output
          console.error("PDF template overlay failed:", e);
          finalBytes = doc.output("arraybuffer");
        }
      } else {
        // No background template; use the jsPDF output directly
        finalBytes = doc.output("arraybuffer");
      }

      // Open in a new window and trigger print
      const blob = new Blob([finalBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const printWindow = window.open(blobUrl, "_blank");

      if (printWindow) {
        printWindow.onload = () => {
          printWindow.focus();
          printWindow.print();
        };
      } else {
        alert("Please allow pop-ups for this site to print the document.");
      }
    };

    const renderInvestigationToPdf = (
      doc,
      startY,
      themeColour,
      investigationData
    ) => {
      if (!Array.isArray(investigationData) || investigationData.length === 0) {
        return startY;
      }

      const investigationsText = investigationData
        .map((data, index) => {
          const details = [data?.body_part, data?.laterality, data?.position]
            .filter(Boolean)
            .join(", ");
          const clinicalNote = data?.clinical_note
            ? `Clinical Note - ${data.clinical_note}`
            : "";
          const descriptor = [details, clinicalNote]
            .filter(Boolean)
            .join(" | ");
          return descriptor
            ? `${index + 1}. ${data?.term || "-"} (${descriptor})`
            : `${index + 1}. ${data?.term || "-"}`;
        })
        .join(" | ");

      if (!investigationsText.trim()) {
        return startY;
      }

      return renderInlineTextSection(
        doc,
        startY,
        "Tests Advised",
        investigationsText
      );
    };

    // const renderHeaderFooter = (data, doc) => {
    //     const pageNumber = doc.internal.getNumberOfPages();
    //     //   const midX = pageWidth / 2 + 10 + PRINT_OFFSET_LEFT; // shift right-column content
    //     const leftColWidth = 180;
    //     const midX = 40 + PRINT_OFFSET_LEFT + leftColWidth;
    //     const rightColumnWidth = pageWidth - midX - 40;

    //     const currentY = 40 + PRINT_OFFSET_TOP; // use margin if needed
    //     // Draw optional overlay watermark (Rx text or image) on top of content
    //     try {
    //         const overlayCenterX = pageWidth / 2 + PRINT_OFFSET_LEFT / 2;
    //         const overlayCenterY = pageHeight / 2;
    //         // If jsPDF supports graphics state, apply low opacity
    //         if (SHOW_RX_OVERLAY) {
    //             if (doc.setGState && doc.GState) {
    //                 doc.setGState(new doc.GState({ opacity: RX_OVERLAY_OPACITY }));
    //             }
    //             if (overlayImageBase64) {
    //                 // Draw provided base64 image overlay covering the printable area
    //                 try {
    //                     doc.addImage(
    //                         `data:image/png;base64,${overlayImageBase64}`,
    //                         "PNG",
    //                         PRINT_OFFSET_LEFT,
    //                         PRINT_OFFSET_TOP,
    //                         pageWidth - 2 * (margin + PRINT_OFFSET_LEFT),
    //                         pageHeight - (PRINT_OFFSET_TOP + 120)
    //                     );
    //                 } catch (imgErr) {
    //                     // Fallback to Rx text if image draw fails
    //                     doc.setFontSize(140);
    //                     doc.setTextColor(180, 180, 180);
    //                     doc.text("Rx", overlayCenterX, overlayCenterY, {
    //                         angle: -30,
    //                         align: "center",
    //                     });
    //                 }
    //             } else {
    //                 // Default Rx watermark text
    //                 doc.setFontSize(140);
    //                 doc.setTextColor(180, 180, 180);
    //                 doc.text("Rx", overlayCenterX, overlayCenterY, {
    //                     angle: -30,
    //                     align: "center",
    //                 });
    //             }
    //             // Reset opacity if supported
    //             if (doc.setGState && doc.GState) {
    //                 doc.setGState(new doc.GState({ opacity: 1 }));
    //             }
    //         }
    //     } catch (e) {
    //         // no-op if watermark drawing fails
    //     }
    //     const brandingItem = brandingData?.find(
    //         (item) => item.name === "branding_statements"
    //     );
    //     console.log("brandingItem", brandingItem);
    //     doc.setFontSize(14);
    //     doc.setTextColor("#000");

    //     const clinicAddress = [
    //         sessionStorage.getItem("facilityAddressLine1"),
    //         sessionStorage.getItem("facilityAddressLine2"),
    //         sessionStorage.getItem("facilityAddressLine3"),
    //     ]
    //         .filter(Boolean)
    //         .join(", ");

    //     doc.setFontSize(10);

    //     const doctorY = currentY + 40;
    //     doc.setFontSize(10);
    //     doc.setTextColor("#000");

    //     // Predeclare values used later for spacing
    //     const rightColumnLineHeight = 12;
    //     const clinicAddressY = doctorY + 45;
    //     let wrappedClinicAddress = [];

    //     if (SHOW_TOP_HEADER) {
    //         doc.text("OP Consultation", 40 + PRINT_OFFSET_LEFT, currentY);

    //         if (collateralImage) {
    //             doc.addImage(
    //                 `data:image/jpeg;base64,${collateralImage}`,
    //                 "JPEG",
    //                 pageWidth - 140,
    //                 currentY - 20,
    //                 100,
    //                 50
    //             );
    //         }

    //         doc.text(`Dr. ${doctorData?.name}`, 40 + PRINT_OFFSET_LEFT, doctorY);
    //         doc.text(
    //             `Reg No: ${doctorData?.registration_no ?? "NA"}`,
    //             40 + PRINT_OFFSET_LEFT,
    //             doctorY + 15
    //         );

    //         // Wrap qualifications text to half page
    //         const qualificationsText = `${doctorData?.qualifications || ""}`;
    //         const wrappedQualifications = doc.splitTextToSize(
    //             qualificationsText,
    //             pageWidth / 2 - 40 // half page width
    //         );

    //         // Draw qualifications (left-aligned, no awkward gaps)
    //         doc.text(wrappedQualifications, 40 + PRINT_OFFSET_LEFT, doctorY + 30);

    //         // Calculate dynamic Y for department/specialization
    //         const qualificationsLineCount = wrappedQualifications.length;
    //         const departmentY = doctorY + 30 + qualificationsLineCount * 12;

    //         // Wrap department/specialization to half page
    //         const departmentText = `${doctorData?.department || ""}${doctorData?.specialization ? " - " + doctorData.specialization : ""
    //             }`;
    //         const wrappedDepartment = doc.splitTextToSize(
    //             departmentText,
    //             pageWidth / 2 - 40
    //         );

    //         // Draw department/specialization (left-aligned)
    //         doc.text(wrappedDepartment, 40 + PRINT_OFFSET_LEFT, departmentY);

    //         if (brandingItem?.content?.collateralBrandStatement) {
    //             doc.text(
    //                 brandingItem.content.collateralBrandStatement,
    //                 pageWidth - 40,
    //                 doctorY,
    //                 {
    //                     align: "right",
    //                 }
    //             );
    //         }
    //         const formattedDate = formatDateIST(new Date().toISOString());

    //         doc.text(`Date: ${formattedDate.split(" ")[0]}`, midX, doctorY + 15);
    //         doc.text(
    //             `Time: ${formattedDate.split(" ").slice(1).join(" ")}`,
    //             midX,
    //             doctorY + 30
    //         );
    //         // Wrap clinic address to fit remaining right-column width after shifting right
    //         const rightColumnWidth = Math.max(80, pageWidth - midX - 40);
    //         const clinicAddressLine = `Clinic Address: ${clinicAddress}`;
    //         wrappedClinicAddress = doc.splitTextToSize(
    //             clinicAddressLine,
    //             rightColumnWidth
    //         );
    //         doc.text(wrappedClinicAddress, midX, clinicAddressY, {
    //             maxWidth: rightColumnWidth,
    //         });

    //     }

    //     // Ensure patient section starts below wrapped clinic address (if shown)
    //     const patientY = Math.max(
    //         doctorY + 85,
    //         clinicAddressY + wrappedClinicAddress.length * rightColumnLineHeight + 5
    //     );
    //     // doc.text(
    //     //     `Patient Name: ${patientData?.name}`,
    //     //     40 + PRINT_OFFSET_LEFT,
    //     //     patientY
    //     // );
    //     // doc.text(
    //     //     `Age: ${patientData?.age}`,
    //     //     40 + PRINT_OFFSET_LEFT,
    //     //     patientY + 15
    //     // );

    //     // LINE 1 — Patient Summary
    //     const patientLine = `Patient: ${patientData?.name} •  Age: ${patientData?.age} years •  Gender: ${patientData?.gender} •   ID: ${patientData?.patient_id}`;
    //     doc.setFontSize(10);
    //     doc.text(
    //         patientLine,
    //         40 + PRINT_OFFSET_LEFT,
    //         patientY,
    //         { maxWidth: pageWidth - (40 + PRINT_OFFSET_LEFT) - 40 }
    //     );

    //     // LINE 2 — Phone Number
    //     doc.text(
    //         `Phone: ${patientData?.phone_no}`,
    //         40 + PRINT_OFFSET_LEFT,
    //         patientY + 15
    //     );

    //     // LINE 3 — Visit Purpose
    //     doc.text(
    //         `Visit Purpose: ${selectedContextDisplay}`,
    //         40 + PRINT_OFFSET_LEFT,
    //         patientY + 30
    //     );

    //     // SMALL SEPARATOR LINE (reduced gap below)
    //     doc.line(
    //         40 + PRINT_OFFSET_LEFT,
    //         patientY + 45,
    //         pageWidth - 40,
    //         patientY + 45
    //     );

    //     // doc.text(
    //     //     `ABHA Address: ${patientData?.abha_id}`,
    //     //     40 + PRINT_OFFSET_LEFT,
    //     //     patientY + 45
    //     // );
    //     // doc.text(
    //     //     `ABHA Number: ${patientData?.abha_no}`,
    //     //     40 + PRINT_OFFSET_LEFT,
    //     //     patientY + 60
    //     // );

    //     // doc.text(`Patient ID: ${patientData?.patient_id}`, midX, patientY, {
    //     //     maxWidth: rightColumnWidth,
    //     // });

    //     // doc.text(`Phone: ${patientData?.phone_no}`, midX, patientY + 15, {
    //     //     maxWidth: rightColumnWidth,
    //     // });

    //     // doc.text(`Consultation ID: ${selectedContext}`, midX, patientY + 30, {
    //     //     maxWidth: rightColumnWidth,
    //     // });

    //     // doc.text(`Visit Purpose: ${selectedContextDisplay}`, midX, patientY + 45, {
    //     //     maxWidth: rightColumnWidth,
    //     // });

    //     // doc.line(
    //     //     40 + PRINT_OFFSET_LEFT,
    //     //     patientY + 75,
    //     //     pageWidth - 40,
    //     //     patientY + 75
    //     // );
    // };
    const renderHeaderFooter = (data, doc) => {
      const pageNumber = doc.internal.getNumberOfPages();
      const midX = pageWidth / 2 + 10 + PRINT_OFFSET_LEFT; // shift right-column content

      const currentY = EFFECTIVE_TOP_MARGIN + PRINT_OFFSET_TOP; // use margin if needed
      // Draw optional overlay watermark (Rx text or image) on top of content
      try {
        const overlayCenterX = pageWidth / 2 + PRINT_OFFSET_LEFT / 2;
        const overlayCenterY = pageHeight / 2;
        // If jsPDF supports graphics state, apply low opacity
        if (SHOW_RX_OVERLAY) {
          if (doc.setGState && doc.GState) {
            doc.setGState(new doc.GState({ opacity: RX_OVERLAY_OPACITY }));
          }
          if (overlayImageBase64) {
            // Draw provided base64 image overlay covering the printable area
            try {
              doc.addImage(
                `data:image/png;base64,${overlayImageBase64}`,
                "PNG",
                PRINT_OFFSET_LEFT,
                PRINT_OFFSET_TOP,
                pageWidth - 2 * (EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT),
                pageHeight - (PRINT_OFFSET_TOP + 120)
              );
            } catch (imgErr) {
              // Fallback to Rx text if image draw fails
              doc.setFontSize(140);
              doc.setTextColor(180, 180, 180);
              doc.text("Rx", overlayCenterX, overlayCenterY, {
                angle: -30,
                align: "center",
              });
            }
          } else {
            // Default Rx watermark text
            doc.setFontSize(140);
            doc.setTextColor(180, 180, 180);
            doc.text("Rx", overlayCenterX, overlayCenterY, {
              angle: -30,
              align: "center",
            });
          }
          // Reset opacity if supported
          if (doc.setGState && doc.GState) {
            doc.setGState(new doc.GState({ opacity: 1 }));
          }
        }
      } catch (e) {
        // no-op if watermark drawing fails
      }
      const brandingItem = brandingData?.find(
        (item) => item.name === "branding_statements"
      );
      console.log("brandingItem", brandingItem);
      doc.setFontSize(14);
      doc.setTextColor("#000");

      const clinicAddress = [
        sessionStorage.getItem("facilityAddressLine1"),
        sessionStorage.getItem("facilityAddressLine2"),
        sessionStorage.getItem("facilityAddressLine3"),
      ]
        .filter(Boolean)
        .join(", ");

      doc.setFontSize(10);

      const doctorY = currentY + 40;
      doc.setFontSize(10);
      doc.setTextColor("#000");

      // Predeclare values used later for spacing
      const rightColumnLineHeight = 12;
      const clinicAddressY = doctorY + 45;
      let wrappedClinicAddress = [];
      let leftY = doctorY;

      if (SHOW_TOP_HEADER) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(
          "Prescription",
          EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
          currentY
        );
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        if (collateralImage) {
          const collateralImageDataUrl = collateralImage.startsWith("data:")
            ? collateralImage
            : `data:image/jpeg;base64,${collateralImage}`;
          try {
            const imageProps = doc.getImageProperties(collateralImageDataUrl);
            const { width: scaledWidth, height: scaledHeight } =
              getScaledDimensions(imageProps.width, imageProps.height, 110, 50);
            doc.addImage(
              collateralImageDataUrl,
              imageProps.fileType || "JPEG",
              pageWidth - scaledWidth - 60,
              currentY - 20,
              scaledWidth,
              scaledHeight
            );
          } catch (imgErr) {
            console.error("Failed to render collateral logo", imgErr);
          }
        }

        // Doctor Name — bold, larger font
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(
          `Dr. ${doctorData?.name}`,
          EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
          doctorY
        );
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        leftY = doctorY + 16;

        // Degree / Qualifications
        const qualificationsText = `${doctorData?.qualifications || ""}`;
        if (qualificationsText.trim()) {
          const wrappedQualifications = doc.splitTextToSize(
            qualificationsText,
            pageWidth / 2 - 40
          );
          doc.text(
            wrappedQualifications,
            EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
            leftY
          );
          leftY += wrappedQualifications.length * 12;
        }

        // Registration No
        doc.text(
          `Reg No: ${doctorData?.registration_no ?? "NA"}`,
          EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
          leftY
        );
        leftY += 12;

        // Contact No
        if (doctorData?.phone_no) {
          doc.text(
            `Contact: ${doctorData.phone_no}`,
            EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
            leftY
          );
          leftY += 12;
        }

        // Email
        if (doctorData?.email) {
          doc.text(
            `Email: ${doctorData.email}`,
            EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
            leftY
          );
          leftY += 12;
        }

        // collateralBrandStatement hidden on prescription
        // if (brandingItem?.content?.collateralBrandStatement) {
        //   doc.text(
        //     brandingItem.content.collateralBrandStatement,
        //     pageWidth - 40,
        //     doctorY,
        //     { align: "right" }
        //   );
        // }
        const formattedDate = formatDateIST(dateForAppointment?.toISOString());

        doc.text(`Date: ${formattedDate.split(" ")[0]}`, midX, doctorY + 15);
        doc.text(
          isTodayOrFuture(dateForAppointment) ? `Time: ${formatDateIST(new Date().toISOString()).split(" ").slice(1).join(" ")}` : `Time: ${startTime}`,
          midX,
          doctorY + 30
        );
        // Wrap clinic address to fit remaining right-column width after shifting right
        const rightColumnWidth = Math.max(80, pageWidth - midX - 40);
        const clinicAddressLine = `Clinic Address: ${clinicAddress}`;
        wrappedClinicAddress = doc.splitTextToSize(
          clinicAddressLine,
          rightColumnWidth
        );
        doc.text(wrappedClinicAddress, midX, clinicAddressY);
      }

      // Ensure patient section starts below wrapped clinic address (if shown)
      const patientY = Math.max(
        leftY + 5,
        clinicAddressY + wrappedClinicAddress.length * rightColumnLineHeight + 5
      );
      // doc.text(
      //   `Patient Name: ${patientData?.name}`,
      //   40 + PRINT_OFFSET_LEFT,
      //   patientY
      // );
      // doc.text(
      //   `Age: ${patientData?.age}`,
      //   40 + PRINT_OFFSET_LEFT,
      //   patientY + 15
      // );
      // doc.text(
      //   `Gender: ${patientData?.gender}`,
      //   40 + PRINT_OFFSET_LEFT,
      //   patientY + 30
      // );
      // doc.text(
      //   `ABHA Address: ${patientData?.abha_id}`,
      //   40 + PRINT_OFFSET_LEFT,
      //   patientY + 45
      // );
      // doc.text(
      //   `ABHA Number: ${patientData?.abha_no}`,
      //   40 + PRINT_OFFSET_LEFT,
      //   patientY + 60
      // );

      // doc.text(`Patient ID: ${patientData?.patient_id}`, midX, patientY);
      // doc.text(`Phone: ${patientData?.phone_no}`, midX, patientY + 15);
      // doc.text(`Consultation ID: ${selectedContext}`, midX, patientY + 30);
      // doc.text(`Visit Purpose: ${selectedContextDisplay}`, midX, patientY + 45);
      doc.setFontSize(10);
      const availableWidth =
        pageWidth -
        (EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT) -
        EFFECTIVE_RIGHT_MARGIN;
      const lineHeight = 12;
      const lineSpacing = 5; // Space between lines

      // LINE 1 — Patient Name (bold)
      const patientNameLine = [
        patientData?.patient_id ? `ID: ${patientData.patient_id}` : null,
        `Patient: ${displayPatientName(patientData?.name)}`,
      ]
        .filter(Boolean)
        .join(" | ");
      doc.setFont("helvetica", "bold");
      const wrappedPatientLine = doc.splitTextToSize(patientNameLine, availableWidth);
      doc.text(wrappedPatientLine, EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT, patientY);
      doc.setFont("helvetica", "normal");
      let patientSectionY = patientY + wrappedPatientLine.length * lineHeight + lineSpacing;

      const appointmentDateTime = (() => {
        if (!dateForAppointment) return null;
        const formattedDateTime = formatDateIST(dateForAppointment.toISOString());
        const datePart = formattedDateTime?.split(" ")?.[0];
        const timePart = isTodayOrFuture(dateForAppointment)
          ? formatDateIST(new Date().toISOString()).split(" ").slice(1).join(" ")
          : startTime;
        if (!datePart && !timePart) return null;
        return `DT: ${[datePart, timePart].filter(Boolean).join(" ")}`;
      })();

      // LINE 2 — Appointment type | Phone | Age | Gender | Date time
      const ageLine = [
        `Appt: ${formatAppointmentTypeForPdf(
          patientData?.appointment_type
        )}`,
        patientData?.phone_no ? `Ph: ${patientData.phone_no}` : null,
        patientData?.age ? `Age: ${patientData.age}y` : null,
        patientData?.gender ? `G: ${patientData.gender}` : null,
        appointmentDateTime,
      ]
        .filter(Boolean)
        .join(" | ");
      if (ageLine) {
        const wrappedAgeLine = doc.splitTextToSize(ageLine, availableWidth);
        doc.text(wrappedAgeLine, EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT, patientSectionY);
        patientSectionY += wrappedAgeLine.length * lineHeight + lineSpacing;
      }

      // ABHA details on a single line when either field is present
      const abhaParts = [];
      if (patientData?.abha_id) {
        abhaParts.push(`ABHA Address: ${patientData.abha_id}`);
      }
      if (patientData?.abha_no) {
        abhaParts.push(`ABHA Number: ${patientData.abha_no}`);
      }
      if (abhaParts.length > 0) {
        const wrappedAbhaLine = doc.splitTextToSize(
          abhaParts.join(" | "),
          availableWidth
        );
        doc.text(
          wrappedAbhaLine,
          EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
          patientSectionY
        );
        patientSectionY += wrappedAbhaLine.length * lineHeight + lineSpacing;
      }

      // SMALL SEPARATOR LINE (positioned dynamically based on actual content height)
      const separatorY = patientSectionY;
      doc.line(
        EFFECTIVE_LEFT_MARGIN + PRINT_OFFSET_LEFT,
        separatorY,
        pageWidth - EFFECTIVE_RIGHT_MARGIN,
        separatorY
      );
      // Return the Y position where body content should begin (just below the separator).
      return separatorY + 15;
    };

    const renderFooter = (doc, pageNumber) => {
      if (!SHOW_FOOTER) return;
      const brandingItem = brandingData?.find(
        (item) => item.name === "branding_statements"
      );
      const themeColour = "#EEEEEE";
      const margin = 5;
      const footerPadding = 10;

      const signatureBlockHeight = 70;
      const signaturePadding = 37;

      const rightX = pageWidth - 200;
      const centerX = pageWidth / 2;

      const poweredText =
        "Enhanced Patient Care Powered by Hlthtek Digital Healthcare Platform (Visit: https://www.hlthtek.com)";
      const logoImg = NavLogoFooter;
      // Original department footer block retained for reference (commented as requested):
      // const departmentText = departments.length
      //   ? departments.map((d) => d.department).join(" | ")
      //   : "N/A";
      // const deptText = `Departments: ${departmentText}`;
      // const wrappedDeptText = doc.splitTextToSize(
      //   deptText,
      //   pageWidth - 2 * margin
      // );
      // const deptLineCount = wrappedDeptText.length;
      // const lineHeight = 12;
      // const baseFooterHeight = 60;
      // const dynamicFooterHeight =
      //   baseFooterHeight + (deptLineCount - 1) * lineHeight;
      // doc.setFillColor(...hexToRgbArray(themeColour));
      // const footerWidth = pageWidth - 80;
      // const footerLeftX = 40;
      // doc.rect(footerLeftX, footerTopY, footerWidth, dynamicFooterHeight, "F");
      // doc.setFontSize(9);
      // doc.setTextColor("#fff");
      // doc.text(wrappedDeptText, centerX, footerTopY + 15, { align: "center" });
      // const poweredY = footerTopY + 15 + deptLineCount * lineHeight;
      // doc.setFontSize(9);
      // doc.text(poweredText, centerX, poweredY, { align: "center" });
      // if (logoImg) {
      //   doc.addImage(logoImg, "PNG", centerX - 15, poweredY + 8, 30, 15);
      // }
      const baseFooterHeight = 56;
      const dynamicFooterHeight = baseFooterHeight;

      const pageBottomY = pageHeight - margin;
      const footerTopY = pageBottomY - dynamicFooterHeight;
      const signatureTopY =
        footerTopY - signatureBlockHeight - signaturePadding;

      // const signature = doctorData?.doctor_signature;
      // const imgType = getImageType(signature);
      // // Move signature & text above it a little
      // const moveUpOffset = 10; // tweak this number to adjust position
      // const sigTopY = signatureTopY - moveUpOffset;
      // const sigImgHeight = 50;
      // const sigImgWidth = 100;

      // const sigLeftX = rightX;

      // // Draw Signature First (at top of block)
      // if (signature) {
      //     doc.addImage(
      //         `data:image/${imgType};base64,${signature}`,
      //         imgType.toUpperCase(),
      //         sigLeftX,
      //         sigTopY,
      //         sigImgWidth,
      //         sigImgHeight
      //     );
      // }

      // // Doctor Text Below Signature
      // const startY = sigTopY + sigImgHeight + 10;
      // doc.setFontSize(10);
      // doc.setTextColor("#000000");

      // doc.text(`Dr. ${doctorData?.name}`, rightX, startY);

      // const rightColumnWidth = pageWidth - rightX - 40; // dynamic column width

      // // Wrap qualifications to fit exactly in right column
      // const wrappedQualificationsRight = doc.splitTextToSize(
      //     `${doctorData?.qualifications || ""}`,
      //     rightColumnWidth
      // );

      // // Draw qualifications
      // doc.text(wrappedQualificationsRight, rightX, startY + 15);

      // // Calculate Y for registration number based on wrapped lines
      // const regNoY =
      //     startY + 15 + wrappedQualificationsRight.length * lineHeight;

      // doc.text(
      //     `Registration No: ${doctorData?.registration_no ?? "NA"}`,
      //     rightX,
      //     regNoY
      // );

      // Footer Background
      const footerWidth =
        pageWidth - EFFECTIVE_LEFT_MARGIN - EFFECTIVE_RIGHT_MARGIN;
      const footerLeftX = EFFECTIVE_LEFT_MARGIN;

      doc.setFillColor(...hexToRgbArray(themeColour));
      doc.rect(footerLeftX, footerTopY, footerWidth, dynamicFooterHeight, "F");

      const lineY = footerTopY + dynamicFooterHeight - 18;
      const textLeftX = footerLeftX + 10;
      const logoWidth = 40;
      const logoHeight = 18;
      const logoX = footerLeftX + footerWidth - logoWidth - 10;
      const disclaimerY = footerTopY + 12;
      const disclaimerWidth = footerWidth - 20;
      const disclaimerText =
        "NB: Patient is at liberty to buy any generic version of the medicine prescribed. In Emergency always consult your nearest ER or available doctor.";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);
      doc.setTextColor("#000000");
      doc.text(disclaimerText, footerLeftX + 10, disclaimerY, {
        maxWidth: disclaimerWidth,
      });

      doc.setFontSize(9);
      doc.setTextColor("#000000");
      doc.text(poweredText, textLeftX, lineY);

      if (logoImg) {
        doc.addImage(
          logoImg,
          "PNG",
          logoX,
          lineY - logoHeight + 6,
          logoWidth,
          logoHeight
        );
      }
    };

    const getImageType = (base64String) => {
      if (!base64String) return null;

      if (base64String.startsWith("/9j/")) {
        return "jpeg";
      } else if (base64String.startsWith("iVBORw0KGgo")) {
        return "png";
      } else {
        return "jpeg"; // Default fallback
      }
    };

    const getScaledDimensions = (width, height, maxWidth, maxHeight) => {
      if (!width || !height) {
        return { width: maxWidth, height: maxHeight };
      }
      const widthRatio = maxWidth / width;
      const heightRatio = maxHeight / height;
      const scale = Math.min(widthRatio, heightRatio, 1);
      return {
        width: width * scale,
        height: height * scale,
      };
    };

    // Helpers
    const hexToRgbArray = (hex) => {
      const bigint = parseInt(hex.replace("#", ""), 16);
      return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    };

    const renderExaminationsToPdf = (
      doc,
      startY,
      themeColour,
      vitals,
      bloodGroup,
      dentalData
    ) => {
      if (!hasVitalValue && !hasDentalData && !bloodGroup) {
        return startY; // nothing to render
      }
      let currentY = startY;

      if (hasVitalValue || bloodGroup) {
        const vitalsParts = [];
        const vitalsWithValues = Array.isArray(vitals)
          ? vitals.filter(
            (v) =>
              v?.value !== "" && v?.value !== null && v?.value !== undefined
          )
          : [];

        vitalsWithValues.forEach((vital) => {
          const vitalValue = `${vital.value} ${vital.sign || ""}`.trim();
          vitalsParts.push(`${vital.name}: ${vitalValue}`);
        });

        const height = vitalsWithValues.find((i) => i.name === "Height")?.value;
        const weight = vitalsWithValues.find((i) => i.name === "Weight")?.value;
        const parsedHeight = parseFloat(height);
        const parsedWeight = parseFloat(weight);
        if (
          !Number.isNaN(parsedHeight) &&
          !Number.isNaN(parsedWeight) &&
          parsedHeight > 0
        ) {
          const bmi = (parsedWeight / Math.pow(parsedHeight / 100, 2)).toFixed(
            2
          );
          vitalsParts.push(`BMI: ${bmi} kg/m2`);
        }

        if (bloodGroup) {
          vitalsParts.push(`Blood Group: ${bloodGroup}`);
        }

        if (vitalsParts.length > 0) {
          currentY = renderInlineTextSection(
            doc,
            currentY,
            "Vitals",
            vitalsParts.join(" | ")
          );
        }
      }

      if (hasDentalData && Array.isArray(dentalData) && dentalData.length > 0) {
        const visibleDental = dentalData.filter(
          (d) => d?.value !== "" && d?.value !== null && d?.value !== undefined
        );
        if (visibleDental.length > 0) {
          const dentalText = visibleDental
            .map((item, index) => {
              const teethNumbers = (item?.id || "")
                .split(",")
                .filter(Boolean)
                .map((id) => id.replace("_", ""))
                .join(", ");
              const segments = [];
              if (teethNumbers) {
                segments.push(`Teeth ${teethNumbers}`);
              }
              if (item?.clinical_note) {
                segments.push(`Note - ${item.clinical_note}`);
              }
              const description =
                segments.length > 0 ? segments.join(" | ") : "-";
              return `${index + 1}. ${description}`;
            })
            .join(" ; ");

          currentY = renderInlineTextSection(
            doc,
            currentY,
            "Dental Examination",
            dentalText
          );
        }
      }

      return currentY;
    };

    const renderMedicalAdviceToPdf = (
      doc,
      startY,
      themeColour,
      selectedSectionsData
    ) => {
      if (
        !selectedSectionsData ||
        !selectedSectionsData.advice ||
        selectedSectionsData.advice.trim().length === 0
      ) {
        console.log("return-------------", selectedSectionsData);
        return startY;
      }
      console.log("i am in------------------------------------");
      return renderInlineTextSection(
        doc,
        startY,
        "Medical Advice",
        selectedSectionsData.advice
      );
    };

    const renderDrugHistoryToPdf = (
      doc,
      startY,
      themeColour,
      historyDetails
    ) => {
      // Check if historyDetails exists and has drug history data
      // Handle different possible structures:
      // 1. historyDetails["Drug History"] with prev and new arrays (medicalBackground structure)
      // 2. historyDetails.drugHistory (direct array)
      // 3. historyDetails["Drug History"] (direct array)
      // 4. oldDrugHistory, pastDrugHistory, or previousDrugHistory
      // 5. Direct array

      let drugHistoryData = null;

      // Check for medicalBackground structure with prev and new
      if (historyDetails?.["Drug History"]) {
        const drugHistoryObj = historyDetails["Drug History"];
        if (drugHistoryObj.prev || drugHistoryObj.new) {
          // Combine prev and new arrays
          drugHistoryData = [
            ...(Array.isArray(drugHistoryObj.prev) ? drugHistoryObj.prev : []),
            ...(Array.isArray(drugHistoryObj.new) ? drugHistoryObj.new : []),
          ];
        } else if (Array.isArray(drugHistoryObj)) {
          // Direct array structure
          drugHistoryData = drugHistoryObj;
        }
      }

      // Fallback to other possible structures
      if (!drugHistoryData || drugHistoryData.length === 0) {
        drugHistoryData =
          historyDetails?.drugHistory ||
          historyDetails?.oldDrugHistory ||
          historyDetails?.pastDrugHistory ||
          historyDetails?.previousDrugHistory ||
          (Array.isArray(historyDetails) ? historyDetails : null);
      }

      if (
        !drugHistoryData ||
        !Array.isArray(drugHistoryData) ||
        drugHistoryData.length === 0
      ) {
        return startY;
      }

      // Format drug history items as text separated by |
      const drugHistoryText = drugHistoryData
        .map((drug, index) => {
          const parts = [];

          // Add drug name (handle both drug_name and medication_name)
          const drugName = drug.drug_name || drug.medication_name;
          if (drugName) {
            parts.push(drugName);
          }

          // Add drug description if available
          if (drug.drug_description) {
            parts.push(`Description: ${drug.drug_description}`);
          }

          // Add duration if available
          if (drug.duration && drug.durationType) {
            parts.push(`Duration: ${drug.duration} ${drug.durationType}`);
          }

          // Add onset date if available (handle both onset_datetime and date_asserted)
          const onsetDate = drug.onset_datetime || drug.date_asserted;
          if (onsetDate) {
            const onsetDateObj = new Date(onsetDate);
            if (!isNaN(onsetDateObj.getTime())) {
              parts.push(`Onset: ${onsetDateObj.toLocaleDateString()}`);
            }
          }

          // Add abatement date if available
          if (drug.abatement_datetime) {
            const abatementDate = new Date(drug.abatement_datetime);
            if (!isNaN(abatementDate.getTime())) {
              parts.push(`Abatement: ${abatementDate.toLocaleDateString()}`);
            }
          }

          // Add clinical note if available (handle both clinical_note and note)
          const note = drug.clinical_note || drug.note;
          if (note) {
            parts.push(`Note: ${note}`);
          }

          // If no parts, return just the index
          if (parts.length === 0) {
            return `${index + 1}. -`;
          }

          return `${index + 1}. ${parts.join(" | ")}`;
        })
        .join(" | ");

      if (!drugHistoryText.trim()) {
        return startY;
      }

      return renderInlineTextSection(
        doc,
        startY,
        "Drug History",
        drugHistoryText
      );
    };

    const renderAppointmentToPdf = (
      doc,
      startY,
      themeColour,
      followUp,
      referral
    ) => {
      if (
        (!Array.isArray(followUp) || followUp.length === 0) &&
        (!Array.isArray(referral) || referral.length === 0)
      ) {
        return startY;
      }

      const followUpData = followUp[0];
      const referralData = referral[0];

      // Build key-value pairs like vitals format
      const followUpReferralParts = [];

      // Follow-up data
      if (followUpData?.service_type) {
        followUpReferralParts.push(followUpData.service_type);
      }
      if (followUpData?.duration && followUpData.durationType) {
        followUpReferralParts.push(
          `${followUpData.duration} ${followUpData.durationType}`
        );
      }

      // Referral data
      if (referralData?.service_description) {
        followUpReferralParts.push(
          `Referral Details: ${referralData.service_description}`
        );
      }
      if (referralData?.service_category) {
        followUpReferralParts.push(
          `Department: ${referralData.service_category}`
        );
      }
      if (referralData?.doctor_details?.name) {
        followUpReferralParts.push(
          `Doctor Name: ${referralData.doctor_details.name}`
        );
      }

      if (followUpReferralParts.length === 0) {
        return startY;
      }

      // Use renderInlineTextSection like vitals - key-value format separated by |
      const followUpReferralText = followUpReferralParts.join(" | ");

      return renderInlineTextSection(
        doc,
        startY,
        "Follow-up & Referral",
        followUpReferralText
      );
    };

    const renderOtherSectionsToPdf = (
      doc,
      startY,
      themeColour,
      sections = []
    ) => {
      if (!Array.isArray(sections) || sections.length === 0) return startY;

      const diagnosisText = sections
        .map((item, index) => {
          const parts = [];
          if (item?.duration && item?.durationType) {
            parts.push(`Duration - ${item.duration} ${item.durationType}`);
          }
          if (item?.clinical_note) {
            parts.push(`Clinical Note - ${item.clinical_note}`);
          }
          if (item?.severity) {
            parts.push(`Severity - ${item.severity}`);
          }
          const details = parts.length ? ` (${parts.join(" | ")})` : "";
          return `${index + 1}. ${item?.term || "-"}` + details;
        })
        .join(" | ");

      if (!diagnosisText.trim()) {
        return startY;
      }

      return renderInlineTextSection(doc, startY, "Diagnosis", diagnosisText);
    };

    const renderAdultVaccinationToPdf = (
      doc,
      startY,
      themeColour,
      vaccinations = []
    ) => {
      if (!Array.isArray(vaccinations) || vaccinations.length === 0) return startY;

      const adultVaccinationText = vaccinations
        .map((item, index) => {
          const vaccine = item?.vaccine_name || item?.vaccine || item?.name || "-";
          const dose = item?.dose ? `Dose: ${item.dose}` : null;
          const date = item?.date_of_administration || item?.date;
          const dateInfo = date ? `Date: ${date}` : null;
          const details = [dose, dateInfo].filter(Boolean).join(" | ");
          return details
            ? `${index + 1}. ${vaccine} (${details})`
            : `${index + 1}. ${vaccine}`;
        })
        .join(" | ");

      if (!adultVaccinationText.trim()) {
        return startY;
      }

      return renderInlineTextSection(
        doc,
        startY,
        "Adult Vaccination",
        adultVaccinationText
      );
    };
    const renderDoctorSignatureBlock = (doc, startY) => {
      const signature = doctorData?.doctor_signature;
      const imgType = signature ? getImageType(signature) : null;

      const blockWidth = 180; // Width of right-side signature block
      const blockX = pageWidth - blockWidth - EFFECTIVE_RIGHT_MARGIN; // right margin from config
      let y = startY;

      doc.setFontSize(10);
      doc.setTextColor("#000");

      // Signature Image (if available)
      if (signature) {
        doc.addImage(
          `data:image/${imgType};base64,${signature}`,
          imgType.toUpperCase(),
          blockX,
          y,
          140,
          60
        );
        y += 70;
      }

      // Doctor Name
      doc.setFont("helvetica", "bold");
      doc.text(`Dr. ${doctorData?.name}`, blockX, y);
      y += 14;

      doc.setFont("helvetica", "normal");

      // Qualifications (wrapped)
      if (doctorData?.qualifications) {
        const wrappedQual = doc.splitTextToSize(
          doctorData.qualifications,
          blockWidth
        );
        doc.text(wrappedQual, blockX, y);
        y += wrappedQual.length * 12;
      }

      // Registration Number
      doc.text(`Reg No: ${doctorData?.registration_no ?? "NA"}`, blockX, y);
      // y += 5;

      return y; // final Y pointer
    };
    const renderChiefComplaintsToPdf = (
      doc,
      startY,
      themeColour,
      selectedSectionsData
    ) => {
      if (
        !Array.isArray(selectedSectionsData) ||
        selectedSectionsData.length === 0
      ) {
        return startY;
      }

      const text = selectedSectionsData
        .map((item, index) => {
          const parts = [];
          if (item?.duration) {
            parts.push(`${item.duration} ${item.durationType || ""}`.trim());
          }
          if (item?.clinical_status_description) {
            parts.push(item.clinical_status_description);
          }
          if (item?.clinical_note) {
            parts.push(item.clinical_note);
          }

          const details =
            parts.length > 0 ? ` (${parts.filter(Boolean).join(", ")})` : "";
          return `${index + 1}. ${item?.condition || "-"}` + details;
        })
        .join(" | ");

      return renderInlineTextSection(doc, startY, "Chief Complaints", text);
    };
    useImperativeHandle(ref, () => ({
      print: (withHeaders, type) => handleDownload(withHeaders, type),
    }));

    console.log("SectionsContent", selectedSectionsData);
    return (
      <>
        {/* <button onClick={handleDownload} className="listening-button">
          Download
        </button> */}
      </>
    );
  }
);
export default React.memo(PrintPrescriptionforButtonDropdown);
